// extracted by mini-css-extract-plugin
export default {"commission":"rFRnlyKh6Ta02rw8PCXh"};